import { useState } from 'react';
import { WizardModal } from '@apply/components';
import { useSteps, WizardDemoSection } from './components/Steps/Steps';
import { useWizardDemoStore } from './state/wizardDemoStore';

export interface WizardModalDemoProps {
    isOpen: boolean;
    onClose: () => void;
}

/** TEMP: Demo of WizardModal. Remove once the modal is in use. */
export const WizardModalDemo = ({ isOpen, onClose }: WizardModalDemoProps) => {
    const [currentStep, set_currentStep] = useState<number>(WizardDemoSection.SetupAndBorrower);

    // A fresh wizard on every open: the Popup keeps its content mounted while hidden, so without this the fields
    // would keep validation state from last time (e.g. "required" errors set when reset() cleared them after closing).
    // Bumped during render when isOpen turns true, so the new instance is what first shows (no flash of the old one).
    const [instanceKey, set_instanceKey] = useState(0);
    const [wasOpen, set_wasOpen] = useState(isOpen);
    if (isOpen !== wasOpen) {
        set_wasOpen(isOpen);
        if (isOpen) {
            set_instanceKey((key) => key + 1);
        }
    }

    // The form data lives in the wizard store (not here), so the steps need nothing passed in.
    const steps = useSteps();

    // Every way out (Save and Exit, Finish, the X, Escape) comes through here.
    const close = () => {
        onClose();
    };

    // Start fresh next time, but only once the modal has finished hiding: resetting while it's still fading out
    // would visibly clear the fields (and flag required ones red) and jump back to the first step.
    const onHidden = () => {
        set_currentStep(WizardDemoSection.SetupAndBorrower);
        useWizardDemoStore.getState().reset();
    };

    return (
        <WizardModal
            key={instanceKey}
            id='wizardModalTest'
            isOpen={isOpen}
            onClose={close}
            onHidden={onHidden}
            title='Wizard Steps'
            steps={steps}
            currentStep={currentStep}
            onStepChange={set_currentStep}
            stepNavigation='all'
            onSaveAndExit={close}
            finishText='Finish'
            sidebarWidth={'280px'}
            height={'90vh'}
            width={'70vw'}
        />
    );
};
